// /src/pages/guestAccess/guestAccessPendingStore.js

let pendingCount = 0;
const listeners = new Set();
let listInvalidationToken = 0;
const listListeners = new Set();

export function getPendingGuestAccessCount() {
  return pendingCount;
}

export function setPendingGuestAccessCount(next) {
  const n = Number(next);
  pendingCount = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;
  listeners.forEach((fn) => {
    try {
      fn(pendingCount);
    } catch {
      // ignore
    }
  });
}

export function subscribePendingGuestAccessCount(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function invalidateGuestAccessPendingList() {
  listInvalidationToken += 1;
  listListeners.forEach((fn) => {
    try {
      fn(listInvalidationToken);
    } catch {
      // ignore
    }
  });
}

export function subscribeGuestAccessPendingList(fn) {
  listListeners.add(fn);
  return () => listListeners.delete(fn);
}

export async function fetchPendingGuestAccessCountOnce() {
  try {
    const { fetchPendingGuestAccessCount } = await import('./guestAccessApi');
    const data = await fetchPendingGuestAccessCount();
    if (data?.ok && typeof data.pendingCount === 'number') {
      setPendingGuestAccessCount(data.pendingCount);
    }
  } catch {
    // ignore
  }
}
